import { getDateString } from "./date-ops";
import { FlightType } from "types/flights/search";
import generalDataManager from "@lib/data/managers/flights/general-data-manager";
import APP_CONFIGURATION from "@lib/app.config";
export const updateUserSearches = async (userId, updateType, search) => {
  try {
    var _APP_CONFIGURATION$co, _localStorage$getItem;
    const saveUserSearches = (_APP_CONFIGURATION$co = APP_CONFIGURATION.config.saveUserSearches) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : false;
    if (!search || !saveUserSearches) return;
    const allSearches = JSON.parse((_localStorage$getItem = localStorage.getItem("userSearches")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : "{}");
    const userSearches = allSearches[userId] || [];
    let title = '';
    let dates = '';
    let details = {};
    let validTo = new Date();
    if (updateType === 'hotels' && search.destination && search.dates && search.occupations) {
      const split = search.destination.value.split(',');
      title = split[0];
      dates = "".concat(getDateString(String(search.dates.check_in), true, true, true), " - ").concat(getDateString(String(search.dates.check_out), true, true, true));
      const rooms = search.occupations.length;
      const totalPersons = search.occupations.reduce((acc, ocuppation) => acc + ocuppation.adults + ocuppation.children, 0);
      details = {
        rooms,
        totalPersons
      };
      validTo = new Date(search.dates.check_in);
    }
    if (updateType === 'cars' && search.pickUpLocation.id && search.pickUpDate && search.dropOffDate) {
      const split = search.pickUpLocation.value.split(',');
      title = split[0];
      dates = "".concat(getDateString(String(search.pickUpDate), true, true, true), " - ").concat(getDateString(String(search.dropOffDate), true, true, true));
      validTo = new Date(search.pickUpDate);
    }
    if (updateType === 'flights' && search.flight_type && search.flight_info && search.flight_info.length > 0) {
      var _origin$municipality_, _destination$municipa;
      const origin = await generalDataManager.getAirportByIata(search.flight_info[0].origin_iata);
      const destination = await generalDataManager.getAirportByIata(search.flight_info[0].destination_iata);
      const lastFlight = search.flight_info[search.flight_info.length - 1];
      title = "".concat((_origin$municipality_ = origin === null || origin === void 0 ? void 0 : origin.municipality_en) !== null && _origin$municipality_ !== void 0 ? _origin$municipality_ : '', " - ").concat((_destination$municipa = destination === null || destination === void 0 ? void 0 : destination.municipality_en) !== null && _destination$municipa !== void 0 ? _destination$municipa : '').concat(search.flight_type === FlightType.MULTI_DESTINATION ? '...' : '');
      if (search.flight_type !== FlightType.ONE_WAY) {
        dates = "".concat(getDateString(String(search.flight_info[0].departure_date), true, true, true), " - ").concat(getDateString(String(search.flight_type !== FlightType.ROUND_TRIP ? lastFlight.departure_date : lastFlight.return_date), true, true, true));
      } else {
        dates = "".concat(getDateString(String(search.flight_info[0].departure_date), true, true, true));
      }
      const passengers = search.passengers_details;
      const totalPersons = passengers.adults + passengers.children + passengers.infants + passengers.infants_with_seat;
      details = {
        passengers: totalPersons,
        flightType: search.flight_type
      };
      validTo = new Date(search.flight_info[0].departure_date);
    }
    const newSearch = getNewSearch(updateType, new Date(), title, dates, details, search, validTo);
    const existingSearchIndex = userSearches.findIndex(x => updateType === 'hotels' && x.type === 'hotels' && x.data.destination.id === search.destination.id || updateType === 'cars' && x.type === 'cars' && x.data.pickUpLocation.id === search.pickUpLocation.id || updateType === 'flights' && x.type === 'flights' && x.data.flight_info[0].origin_iata === search.flight_info[0].origin_iata && x.data.flight_info[0].destination_iata === search.flight_info[0].destination_iata && x.data.flight_type === search.flight_type);

    // Update or Add
    if (existingSearchIndex !== -1) {
      userSearches[existingSearchIndex].searchTime = newSearch.searchTime;
      userSearches[existingSearchIndex].dates = newSearch.dates;
      userSearches[existingSearchIndex].details = newSearch.details;
      userSearches[existingSearchIndex].data = newSearch.data;
      userSearches[existingSearchIndex].validTo = newSearch.validTo;
    } else {
      userSearches.unshift(newSearch);
    }
    allSearches[userId] = userSearches.slice(0, 8);
    localStorage.setItem("userSearches", JSON.stringify(allSearches));
  } catch (error) {
    console.error("Error updating user searches:", error);
  }
};
const getNewSearch = (type, searchTime, title, dates, details, data, validTo) => {
  const adjustedValidTo = new Date(validTo);
  adjustedValidTo.setHours(0, 0, 0, 0);
  return {
    type,
    searchTime,
    title,
    dates,
    details,
    data,
    validTo: adjustedValidTo
  };
};